module.exports = __webpack_public_path__ + "img/Avatar4.7c725e4b.png";